/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useAthletesList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const formatLabel = ({ id, fullName, firstName, lastName }) => {
  if (!lastName && !firstName && !fullName) return `id: ${id}`;

  if (!lastName && !firstName) return fullName;

  if (!firstName?.trim()) return lastName;

  return `${lastName?.toUpperCase()}, ${firstName}`;
};

const AthleteSelect = ({ placeholder = 'Type the name of athlete...', perPage = 20, queryVariables, ...props }) => (
  <SearchableEntitySelect
    placeholder={placeholder}
    useList={useAthletesList}
    perPage={perPage}
    formatLabel={formatLabel}
    // TODO: move sort options to constants
    queryVariables={{ sort: 'name', ...queryVariables }}
    {...props}
  />
);

export default AthleteSelect;
